const initMobileSubMenu = () => {
    const submenuArrows = document.querySelectorAll(".mobile-menu-arrow");

    if (!submenuArrows.length) {
        return;
    }

    const clickHandler = (arrow) => {
        const submenuContainer = arrow.closest(".gh-mobile-menu__item");
        if (!submenuContainer) {
            return;
        }

        const submenuList = submenuContainer.querySelector(".gh-mobile-submenu");
        if (!submenuList) {
            return;
        }

        if (submenuContainer.classList.contains("active")) {
            submenuContainer.classList.remove("active");
            submenuList.style.height = "0px";
        } else {
            submenuContainer.classList.add("active");
            
            const submenuItems = submenuList.querySelectorAll(".gh-mobile-submenu__item");
            
            const submenuHeight = Array.from(submenuItems).reduce(
                (accumulator, currentValue) => accumulator + currentValue.offsetHeight,
                0
            );
            submenuList.style.height = `${submenuHeight}px`;
        }
    };

    submenuArrows.forEach((arrow) => {
        arrow.addEventListener("click", () => clickHandler(arrow));
    });
};

export { initMobileSubMenu };
